define(['jquery',
        'core/urls',
        'core/utilities',
        'core/loading-animation',
        'components/selectize',
        'components/quill-editor',
        "components/modal",
    ],
    function($, reverse_url, utilities, loading_animation, selectize_util, quillEditor, modal) {

        let nodes = {
            form: document.querySelector("form"),
            submit: document.querySelector("#automation-edit-button-save"),
            emailWrapper: document.querySelector(".form-group.email"),
            actionSelector: document.querySelector("#actionsInput"),
            errorList: document.querySelectorAll(".errors > .errorlist > li"),
            createTicketAlert: document.getElementById('create-ticket-alert'),
            loaderElement: document.querySelector(".marketing-loader"),
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
            emailPreview: {
                button: document.querySelector("button.preview-email"),
                modalTemplate: document.querySelector(".modal-template-email-preview"),
                logo: document.querySelector(".modal-template-email-preview .logo"),
                body: document.querySelector(".modal-template-email-preview .body"),
            }
        }

        let createdModal = modal.create(nodes.modal, function (el) {});
        let qEditor;
        let emailContactCharLimit = 500;

        let showValidationErrors = () => {
            nodes.errorList.forEach(error => {
                let errorType = error.firstChild.textContent;
                let errorNode = document.querySelector(`.error-${errorType}`);

                if(errorNode) errorNode.classList.remove("hide")

                if(errorType === "__all__") {
                    errorNode.innerText = error.querySelector("li").innerText;
                }
            })
        }

        let loadData = ($element, value) => {
            let xhr;
            let url = value?reverse_url[$element.data('load-depended')](value):reverse_url[$element.data('load')]();
            let $select_input_selectized = $element.selectize({
                plugins: selectize_util.plugins($element, 'loading_spinner'),
                create: false,
                createOnBlur: false
            })[0].selectize;
            let selected = $element.data('selected');

            $element.on('change', function(event) {
                $element.parent().find('.name_js').val(event.target.innerText);
                let action = $('#action_type').val();

                    let deps = $('#' + action).find('[data-depends-on=' + $element.attr('id') + ']');
                    if (deps.length) {
                        if(event.target.value) {
                            loadData(deps, event.target.value);
                        }else {
                            let s = deps.selectize({})[0].selectize
                            s.clearOptions();
                            s.addOption({"value": "", "text": deps.data('empty')});
                            s.setValue("");

                        }
                    }
            });

            $select_input_selectized.load(function(callback) {
                $select_input_selectized.disable();
                $select_input_selectized.clearOptions();
                xhr && xhr.abort();
                xhr = $.ajax({
                    type: 'GET',
                    url: url,
                    timeout: 30 * 1000,
                    global: false,
                    error: function() {
                        callback();
                        $element.siblings('p.alert').removeClass('collapse');
                        $element.siblings('.selectize-control').addClass("disabled");
                        nodes.submit.classList.add("disabled");
                    },
                    success: function (data) {
                        nodes.submit.classList.remove("disabled");
                        var options = [];
                        $element.siblings('p.alert').addClass('collapse');
                        $element.siblings('.selectize-control').removeClass("disabled");
                        
                        if($element.data('empty')){
                            options.push({'value': "", 'text': $element.data('empty')});
                        }
                        data.forEach(function(item) {
                            options.push({'value': item.id, 'text': item.name});
                            if (!selected && !$element.data('empty')){
                                selected = item.id;
                            }
                        });
                        callback(options);

                        $select_input_selectized.setValue(selected);

                    }
                });
            });
        }

        let toggleVisisbility = (widget, newState) => {
            if (widget.is(':visible') !== newState) {
                widget.toggleClass('show', newState);
            }

            $('.action_js input').prop('disabled', true);
            $('.action_js textarea').prop('disabled', true);
            $('.action_js select').prop('disabled', true);

            if(newState === true) {
                widget.find('input').prop('disabled', false);
                widget.find('textarea').prop('disabled', false);
                widget.find('select').prop('disabled', false);
            }
        }

        let insertAtCursor = (field, value) => {
            //IE support
            if (document.selection) {
                field.focus();
                sel = document.selection.createRange();
                sel.text = value;
            }
            else if (field.selectionStart || field.selectionStart == '0') {
                var startPos = field.selectionStart;
                var endPos = field.selectionEnd;
                field.value = field.value.substring(0, startPos)
                    + value
                    + field.value.substring(endPos, field.value.length);
            } else {
                field.value += value;
            }
        }

        let toggleLinkState = (input, links) => {
            let passingCondition;
            links.forEach(link => {
                passingCondition = input.value.indexOf(`{${link.dataset.variable}}`) > -1

                if (passingCondition) {
                    link.classList.add("disabled");
                } else {
                    link.classList.remove("disabled");
                }
            })
        }

        function addVariablePlaceholder(event){
            event.preventDefault();
            let link = event.target;
            let variable = link.dataset.variable_for;
            let input = document.querySelector(`#${variable}`)

            insertAtCursor(input, `{${link.dataset.variable}}`);
            link.classList.add("disabled");
            input.click();
        }
        
        let addVariableFunctionality = (inputSelector, variableWrapSelector) => {
            let input = document.querySelector(inputSelector)
            let variableWrap = document.querySelector(`.variable-wrap${variableWrapSelector}`);
            if (!input) return;

            let addVariableLinks = variableWrap.querySelectorAll("a.add-variable");

            toggleLinkState(input, addVariableLinks);

            addVariableLinks.forEach(link => {
                link.addEventListener("click", addVariablePlaceholder);
            })

            input.addEventListener("keyup", () => {
                toggleLinkState(input, addVariableLinks);
            })
        }

        let updateWidgetVisibility = () => {
            nodes.submit.classList.remove("disabled");
            let actionType = $('#action_type').val();
            toggleVisisbility($('.action_js'), false);
            toggleVisisbility($('#'+ actionType), true);
            $('#'+ actionType + ' [data-load]').each(function (i, element) {
                loadData($(element));
            });

            if (actionType === "SEND_EMAIL_TO_CONTACT") {
                if(!qEditor) {
                    qEditor = quillEditor({
                        textareaId: '#respondToContactBody',
                        charLimit: emailContactCharLimit,
                        variableWrapSelector: ".respond-to-contact-body",
                        placeholder: `
                                        Write the email that will be sent to your contacts here. 
                                        You can style the text and embed URLs with the buttons above, 
                                        and you can insert placeholders with the options below.`,
                    });
                }
                
                addVariableFunctionality("#respondToContactSubject", ".respond-to-contact-subject");
            }
        }

        let createScoreEventListeners = (nativeOptions) => {
            let projectScores = document.querySelectorAll(".styled-project-survey-scores .option");

            projectScores.forEach((score, i) => {
                score.addEventListener("click", () => {
                    if(score.classList.contains("selected")) {
                        score.classList.remove("selected");
                        nativeOptions[i].selected = false;
                    } else {
                        score.classList.add("selected");
                        nativeOptions[i].selected = true;
                    }
                })
            })
        }

        let styleProjectScores = () => {
            let selectElement = document.querySelector(".project-survey-scores");
            let selectOptions = selectElement.querySelectorAll("option");

            let stylizedElement = document.createElement("div");
            stylizedElement.classList.add("styled-project-survey-scores");
            selectOptions.forEach(option => {
                let styledOption = document.createElement("div");
                let optionOutline = document.createElement("div");
                optionOutline.classList.add("outline");
                styledOption.dataset.value = option.value;
                styledOption.innerText = option.innerText;

                let className = "positive";
                if(option.value == 3) className = "neutral";
                if(option.value < 3) className = "negative";

                styledOption.classList.add("option", className);

                // pre-select any existing selections if editing a rule
                if(option.selected) {
                    styledOption.classList.add("selected");
                }

                styledOption.appendChild(optionOutline);
                stylizedElement.appendChild(styledOption)
            })

            selectElement.after(stylizedElement);

            createScoreEventListeners(selectOptions);
        }


        return {
            init: function () {
                updateWidgetVisibility();
                $('#action_type').change(updateWidgetVisibility);

                addVariableFunctionality("#project_ticket_title", ".create-project-ticket");
                addVariableFunctionality("#service_ticket_title", ".create-service-ticket");

                styleProjectScores();

                let updateCheckboxes = () => {
                    if ($("#id_comment").prop('checked')) {
                        $(".has-marketing-permissions").removeClass("disabled");
                        $("#id_without_comment").prop("checked", false);
                    }else{
                        $("#id_marketing_permissions").prop("checked", false);
                        $(".has-marketing-permissions").addClass("disabled");
                    }
                }

                $("#id_comment").change(event => {
                    updateCheckboxes();
                });

                $("#id_without_comment").change(event => {
                    if(event.target.checked){
                        $("#id_comment").prop("checked", false);
                        updateCheckboxes();
                    }
                });

                updateCheckboxes();
                showValidationErrors();

                utilities.enableInputResets();
                utilities.addCharacterCount("#ticket_title", 70)
                utilities.addCharacterCount("#project_ticket_title", 70)
                utilities.addCharacterCount("#respondToContactSubject", 60)

                utilities.enableLogoPicker(nodes.modal);

                nodes.emailPreview.button.addEventListener("click", (event) => {
                    event.preventDefault();
                    nodes.emailPreview.logo.classList.remove("visible")
                    nodes.emailPreview.body.innerHTML = "";

                    let logo = document.querySelector(".uploader__withlogo");

                    if(logo && !logo.classList.contains("disabled")) {
                        nodes.emailPreview.logo.style = logo.getAttribute("style");
                        nodes.emailPreview.logo.classList.add("visible")
                    }

                    let htmlBody = qEditor.component().root.innerHTML;
                    htmlBody = htmlBody.replace("{comment}", "This is a sample comment.");
                    htmlBody = htmlBody.replace("{first_name}", "Alex");
                    htmlBody = htmlBody.replace("{scores}", "5, 4, 5, 5, 4");
                    htmlBody = htmlBody.replace("{project_name}", "System Upgrade");
                    nodes.emailPreview.body.innerHTML = htmlBody;
                    
                    createdModal.open(null, () => {}, nodes.emailPreview.modalTemplate);  
                })

                nodes.submit.addEventListener("click", (e) => {
                    e.preventDefault();

                    let validFields = true;
                    let nameInput = document.querySelector("input[name='name']");
                    let nameErrorNode = document.querySelector(".error-name");
                    if (!nameInput.value.length) {
                        validFields = false;
                        nameInput.classList.add("error")
                        nameErrorNode.classList.remove("hide");
                    } else {
                        nameInput.classList.remove("error")
                        nameErrorNode.classList.add("hide");
                    }

                    let actionType = $('#action_type').val();
                    if(actionType === "CREATE_SERVICE_TICKET" || actionType === "CREATE_PROJECTS_TICKET") {
                        let ticketTitle = $('#ticket_title');
                        let errorNode = $(".create-ticket-tile-error");
                        if (ticketTitle.length) {
                            if (!ticketTitle.val()) {
                                validFields = false;
                                errorNode.text("Please enter a title")
                                errorNode.removeClass("hide");
                                ticketTitle.addClass("error");
                            } else if (ticketTitle.val().length > ticketTitle.attr("maxlength")) {
                                validFields = false;
                                errorNode.text(`Please limit title to ${ticketTitle.attr("maxlength")} characters`)
                                errorNode.removeClass("hide");
                                ticketTitle.addClass("error");
                            } else {
                                errorNode.addClass("hide");
                                ticketTitle.removeClass("error");
                            }
                        }
                    }

                    if (actionType === "SEND_EMAIL_TO_CONTACT") {
                
                        let emailSubject = document.querySelector("#respondToContactSubject");
                        let emailBody = document.querySelector("#respondToContactBody")
                        let quillBody = document.querySelector("#quillEditor");
                        let quillInside = quillBody.querySelector(".ql-editor");

                        // take the Quill Rich Text value and add it to #respondToContactBody for submit
                        emailBody.value = qEditor.component().root.innerHTML;

                        if(emailSubject.value.trim() === '') {
                            validFields = false;
                            let errorNode = document.querySelector(".respond-to-contact-subject-error");
                            errorNode.classList.remove("hide");
                            emailSubject.classList.add("danger");
                        }
        
                        // use regex to check if quill editor is empty - ignoring empty tags
                        var regex = /(<([^>]+)>)/ig

                        if(emailBody.value.replace(regex, "").length === 0 || emailBody.value === '<p><br></p>' || emailBody.value === '<p> </p>') {
                            validFields = false;
                            let errorNode = document.querySelector(".respond-to-contact-email-error");
                            errorNode.innerText = errorNode.dataset.empty;
                            errorNode.classList.remove("hide");
                            quillInside.classList.add("danger");
                        }

                        if(emailBody.value.replace(regex, "").length > emailContactCharLimit) {
                            validFields = false;
                            let errorNode = document.querySelector(".respond-to-contact-email-error");
                            errorNode.innerText = errorNode.dataset.tooLong;
                            errorNode.classList.remove("hide");
                            quillInside.classList.add("danger");
                        }

                        if(emailBody.value.indexOf("<a href=") > -1 && (emailBody.value.indexOf('<a href="http') === -1 && emailBody.value.indexOf('<a href="mailto') === -1)) {
                            validFields = false;
                            let errorNode = document.querySelector(".respond-to-contact-email-error");
                            errorNode.innerText = errorNode.dataset.improperLink;
                            errorNode.classList.remove("hide");
                            quillInside.classList.add("danger");
                        }                        
                    }

                    if(validFields) {
                        nodes.form.submit();
                    } else {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(".error:visible").offset().top
                        }, 400);
                    }
                })
                
                loading_animation.complete();
            }
        }
    }
);
